import React from 'react';
import '../css/navBar.css';
import '../css/registro.css';

function BtnGuardarEdit(props){
      
    return(  
        <>  
            
            <div className={props.className}>
                <div className='col'>
                    <button class="btn colorPrincipal text-white bold-botones" type="submit" onClick={()=>props.guardar(props.zona)}>{props.text}</button>
                </div>
            </div>
        </>
    );
}

export default BtnGuardarEdit;